export default "__VITE_ASSET__CN4OwlK0__"